/* global allTrims */
import Vue from 'vue'
import global_mixin from './global_mixins.js'
import '../css/product_search.css'
var _ = require('lodash')
// import VueGallery from 'vue-gallery'
import VueGallery from '../components/Gallery.vue'
import { searchColors, tileFilters, searchSeries, getTile, bookmarkedTiles, tilesForColor } from '../graphql/queries'
import gql from 'graphql-tag'
var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -20,
  force: true,
  cancelable: false,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})





var URLSearchParams = require('url-search-params')
let urlParams = new URLSearchParams(window.location.search)

const app = new Vue({
  el: '#app',
  components: {
    'gallery': VueGallery
  },
  data() {
    return {
      /*tileSizes: {},
      quantities: {},
      quantityUpdated: true,*/
      currentTileID: null,
      paginationDirection: 'forward',
      searchTileAfter: undefined,
      searchTileBefore: undefined,
      searchingTiles: true,
      searchingCollections: false,
      resultsPerPage: "12",
      selectedSeries1: '',
      selectedSeries1SKU: '',
      tileResults: [],
      collectionResults: [],
      tileLookups: '',
      checkedAlls: [],
      checkedSeries: [],
      checkedDecoratives: [],
      checkedColors: [],
      checkedLooks: [],
      checkedSizes: [],
      checkedShapes: [],
      checkedTypes: [],
      checkedMosaics: [],
      checkedTrims: [],
      checkedApplications: [],
      checkedThickness: [],
      checkedFinish: [],
      checkedEdge: [],
      checkedShadeVariationsTile: [],
      checkedShadeVariationsSeries: [],
      checkedCountry: [],
      checkedInteriorDesign: [],
      isMicroban: null,
      isMadeInUSA: null,
      openSeriesFilter: false,
      openDecorativesFilter: false,
      openColorFilter: false,
      openLookFilter: false,
      openSizeFilter: false,
      openShapeFilter: false,
      openTypeFilter: false,
      openMosaicFilter: false,
      openDecorativesFilter: false,
      openTrimFilter: false,
      galleryIndex: null,
      galleryKey: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
      tilePopupImage: null,
      tilePopupImageIndex: 0,
      resultsPage: 1,
      resultsPageMax: 1,
      resultsPageSelect: null,
      totalTiles: 0,
      firstLimit: 0,
      lastLimit: 0,
      allTrims: false,
      allMosaics: false,
      allDecoratives: false,
      window: {
        width: 0,
      }
    }
  },
  apollo: {
    currentTileQuery: {
      query: getTile,
      update: data => data.tile,
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        }
        else {
          console.error(error)
        }
      },
      variables() {
        return {
          id: (this.currentTileID) ? this.encodeTileID(this.currentTileID) : undefined
        }
      },
      skip() {
        return this.currentTileID === null
      },
      // watchLoading(isLoading) {
      //   this.isLoading = isLoading
      // },
    },
    searchColors: {
      query: searchColors,
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        }
        else {
          console.error(error)
        }
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
      skip() {
        return !this.cacheLoaded
      },
      variables() {
        return {
          first: 2000,
          filter: {
            "onlyTrims": {"term": false}
          }
        }
        
      },
    },
    searchSeries: {
      query: searchSeries,
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        }
        else {
          console.error(error)
        }
      },
      variables() {
        return {
          first: 100,
          filter: {
            active: {"value": true}
          }
        }
      },
      skip() {
        return !this.cacheLoaded
      },
      // watchLoading(isLoading) {
      //   this.isLoading = isLoading
      // },
    },
    filters: {
      query: tileFilters,
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        }
        else {
          console.error(error)
        }
      },
      // watchLoading(isLoading) {
      //   this.isLoading = isLoading
      // },
      skip() {
        return !this.cacheLoaded
      },
      update: data => data.tileFilters
    },
    bookmarkedTiles: {
      query: bookmarkedTiles,
      update: data => data.allTiles,
      result({ data, loading, networkStatus }) {
        data = data.allTiles
        this.sampleOrders = []
        this.$ls.set('bookmarked_sampleorder_skus', JSON.stringify(Array.from(new Set(this.bookmarked_sampleorder_skus))))
        if (data.edges && data.edges.length > 0) {
          for (const tile of data.edges) {
            if (_.find(this.sampleOrders, { 'sku': tile.node.sku }) === undefined) {
              this.addSampleToCart(tile.node)
            }
          }
        }
      },
      variables() {
        return {
          id: this.encodedBookmarks,
        }
      },
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.$ls.remove('apollo-cache-persist')
        }
        else {
          console.error(error)
        }
      },
      skip() {
        return !(this.cacheLoaded && this.encodedBookmarks.length > 0)
      },
      /*watchLoading(isLoading) {
        this.isLoading = isLoading
      },*/
    },
    tilesForColor: {
      query: tilesForColor,
      update: data => data.allColors,
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.$ls.remove('apollo-cache-persist')
        }
        else {
          console.error(error)
        }
      },
      variables() {
        return {
          id: this.uniqueColorLookups,
          unavailableForSampleOrder: false,
          excludeCutSample: false
        }
      },
      skip() {
        return this.uniqueColorLookups.length === 0
      },
      watchLoading(isLoading) {
        /*this.isLoading = isLoading*/
      },
    },
    allTilesForColor: {
      query: tilesForColor,
      update: data => data.allColors,
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.$ls.remove('apollo-cache-persist')
        }
        else {
          console.error(error)
        }
      },
      variables() {
        return {
          id: this.tileLookups,
          excludeCutSample: true
        }
      },
      skip() {
        return this.tileLookups.length === 0
      },
      watchLoading(isLoading) {
        /*this.isLoading = isLoading*/
      },
    },
  },
  created() {
    this.loadComparisons()
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  async mounted() {
    this.loadBookmarks()
    if (urlParams.has('open')) {
      switch (urlParams.get('open')) {
        case 'collection':
          // this.openSeriesFilter = true
          this.searchingTiles = false
          this.searchingCollections = true
          break
        case 'color':
          this.openColorFilter = true
          break
        case 'look':
          this.openLookFilter = true
          break
        case 'size':
          this.openSizeFilter = true
          break
        case 'shape':
          this.openShapeFilter = true
          break
        case 'type':
          this.openTypeFilter = true
          break
        case 'trim':
          this.openTrimFilter = true
          break
        case 'mosaic':
          this.openMosaicFilter = true
          await this.toggleAllMosaics()
          break
        case 'decoratives':
          this.openDecorativesFilter = true
          await this.toggleAllDecoratives()
          break
      }
    }
    if (urlParams.has('color')) {
      this.checkedColors.push(urlParams.get('color'))
    }
    if (urlParams.has('look')) {
      this.checkedLooks.push(urlParams.get('look'))
    }
    if (urlParams.has('type')) {
      this.checkedTypes.push(urlParams.get('type'))
    }
    // if (this.$ls.get('searching_state', 'tiles') == 'collections') {
    //   this.searchingTiles = false
    //   this.searchingCollections = true
    // } else {
    //   this.searchingTiles = true
    //   this.searchingCollections = false
    // }
    // this.reloadTileData()
    // this.reloadCollectionData()
  },
  methods: {
    async toggleAllMosaics() {
      if (this.filters && this.filters.mosaics && this.filters.mosaics.length > 0) {
        this.checkedAlls.push('mosaics')
      }
      else {
        await new Promise(resolve => setTimeout(async() => await this.toggleAllMosaics(), 500));
      }
    },
    async toggleAllDecoratives() {
      if (this.filters && this.filters.decoratives && this.filters.decoratives.length > 0) {
        this.checkedAlls.push('decoratives')
      }
      else {
        await new Promise(resolve => setTimeout(async() => await this.toggleAllDecoratives(), 500));
      }
    },
    loadTileData: _.throttle(async function(tile) {
      try{
        this.currentTileID = this.decodeRelayID(tile.tileId)
      } catch(err) {
        this.currentTileID = tile.tileId
      }
      /*this.currentTileID = tile.tileId*/
      this.tileLookups = window.btoa("ColorGraph:"+this.decodeRelayID(tile.id))
    }, 500),
    sortShadeVariation(items) {
      return _.sortBy(items, function(element) {
        var rank = {
          'Uniform Appearance': 1,
          'Slight Variation': 2,
          'Moderate Variation': 3,
          'Random Variation': 4,
          'N/A': 5
        }
        return rank[element];
      })
    },
    clearFilters() {
      this.checkedAlls = []
      this.checkedSeries = []
      this.checkedColors = []
      this.checkedLooks = []
      this.checkedSizes = []
      this.checkedShapes = []
      this.checkedDecoratives = []
      this.checkedTypes = []
      this.checkedMosaics = []
      this.checkedTrims = []
      this.checkedApplications = []
      this.checkedThickness = []
      this.checkedFinish = []
      this.checkedEdge = []
      this.checkedShadeVariationsTile = []
      this.checkedShadeVariationsSeries = []
      this.checkedCountry = []
      this.checkedInteriorDesign = []
      this.isMicroban = null
      this.isMadeInUSA = null
      this.resultsPage = 1
      // if(this.searchingTiles) {
      //   this.reloadTileData()
      // } else {
      //   this.reloadCollectionData()
      // }
    },
    handleAllTrimClick() {
      setTimeout(() => { this.reloadTileData() }, 500)
    },
    handleResize() {
      this.window.width = window.innerWidth;
    },
    getTileImage(tile){
      let index = 0
      if(this.checkedMosaics.length == 1){
        return tile.mosaicImages.split(',')[tile.mosaics.split(',').indexOf(this.checkedMosaics[0])]
      } else if(this.checkedMosaics.length > 1){
        let result = tile.mosaicImages.split(',')[tile.mosaics.split(',').indexOf(this.checkedMosaics[0])]
        for(let i of tile.mosaics.split(',')){
          for(let e of this.checkedMosaics){
            if(i == e){
              result = tile.mosaicImages.split(',')[tile.mosaics.split(',').indexOf(e)]
              index = tile.mosaics.split(',').indexOf(e)
            }
          }
        }
        return result
      } else {
        return tile.squareImages.split(',')[0]
      }
    },
    checkMosaics(mosaics){
      if(this.checkedMosaics.includes(mosaics)){
        return true
      } else {
        return false
      }
    }
    
  },
  computed: {
    galleryContent() {
      let galleryContent = []
      if (this.currentTileQuery) {
        for (const e of this.currentTileData.tileImages.edges) {
          galleryContent.push({
            'id': e.node.id,
            'type': 'image',
            'description': `SKU: ${this.currentTileData.sku} <br /> Series: ${this.currentTileData.series.name} <br /> Color: ${this.currentTileData.color.name} <br /> Shape: ${this.currentTileData.shape.code}`,
            'thumbnail': e.node.publicThumbnail,
            'original_image': e.node.originalImage,
            'large_image': e.node.largeImage,
            'larger_image': e.node.largerImage,
            'url': e.node.originalImage
          })
        }
        for (const e of this.currentTileData.scenes.edges) {
          galleryContent.push({
            'id': e.node.id,
            'type': 'image',
            'description': `SKU: ${this.currentTileData.sku} <br /> Series: ${this.currentTileData.series.name} <br /> Color: ${this.currentTileData.color.name} <br /> Shape: ${this.currentTileData.shape.code}`,
            'thumbnail': e.node.publicThumbnail,
            'original_image': e.node.originalImage,
            'large_image': e.node.largeImage,
            'larger_image': e.node.largeImage,
            'url': e.node.originalImage
          })
        }
        if (this.currentTileData.series.videoUrl) {
          galleryContent.push({
            'id': this.currentTileData.series.id,
            'type': 'video',
            'youtubeID': this.currentTileData.series.videoYoutubeId,
            'description': `SKU: ${this.currentTileData.sku} <br /> Series: ${this.currentTileData.series.name} <br /> Color: ${this.currentTileData.color.name} <br /> Shape: ${this.currentTileData.shape.code}`,
            'url': this.currentTileData.series.videoUrl,
            'poster': this.currentTileData.series.videoPosterImage
          })
        }
      }
      return galleryContent
    },
    lightboxContent() {
      let lightboxContent = []
      for (const e of this.galleryContent) {
        if (e.type == 'video') {
          lightboxContent.push({
            // title: e.description,
            the_description: e.description,
            href: e.url,
            type: 'text/html',
            youtube: e.youtubeID,
            poster: e.poster,
          })
        }
        else {
          lightboxContent.push({
            image: e.larger_image,
            // title: e.description,
            the_description: e.description,
            href: e.larger_image,
          })
        }
      }
      return lightboxContent
    },
    currentTileData() {
      if (this.currentTileQuery) {
        return this.currentTileQuery
      }
      else {
        return {
          id: '',
          sku: '',
          series: {
            name: ''
          },
          color: {
            name: ''
          },
          shape: {
            size: ''
          },
          bodyComposition: '',
          seriesUrl: '',
          literaturePdf: '',
          ecoScoreCardLink: ''
        }
      }
    },
    encodedBookmarks() {
      let bookmarks = []
      for (const bookmark of this.bookmarked_sampleorder_skus) {
        bookmarks.push(this.encodeTileID(bookmark))
      }
      return bookmarks
    },
    groupedTilesForColor() {
      let groupedData = []
      if (this.tilesForColor && this.tilesForColor.edges) {
        groupedData = _.groupBy(this.tilesForColor.edges, (e) => { return e.node.id })
      }
      return groupedData
    },
    groupedTiles() {
      let groupedData = []
      if (this.allTilesForColor.edges) {
        //groupedData = _.groupBy(this.allTilesForColor.edges, (e) => { return e.node.id })
        let trims = []
        let decoratives = []
        let tiles = []
        let mosaics = []
        for(let tile of this.allTilesForColor.edges[0].node.tiles.edges){
          console.log(tile)
          if(tile.node.shape.decoratives){
            decoratives.push(tile)
          } else if(tile.node.shape.trimType){
            trims.push(tile)
          } else if(tile.node.shape.mosaic){
            mosaics.push(tile)
          } else {
            tiles.push(tile)
          }
        }
        groupedData = _.orderBy(tiles,['node.shape.position'], ['asc'])
        groupedData = groupedData.concat(mosaics, decoratives, trims)
        
      }
      return groupedData
    },
    uniqueColorLookups() {
      return _.uniq(this.colorLookups)
    },
    /*uniqueTileLookups() {
      return _.uniq(this.tileLookups)
    },*/
    totalSamples() {
      return this.orderedQuantityList.reduce((a, b) => a + b, 0)
    },
    orderedQuantityList() {
      let skuList = []
      if (this.quantityUpdated) {
        for (const order of this.sampleOrders) {
          skuList.push((order.quantity) ? order.quantity : 1)
        }
        this.quantityUpdated = false
      }
      return skuList
    },
    hasTileFilters() {
      return (this.checkedSeries.length > 0 || this.checkedColors.length > 0 || this.checkedLooks.length > 0 ||
        this.checkedSizes.length > 0 || this.checkedDecoratives.length > 0 || this.checkedShapes.length > 0 || this.checkedTypes.length > 0 ||
        this.checkedMosaics.length > 0 || this.checkedTrims.length > 0 || this.checkedApplications.length > 0 ||
        this.checkedThickness.length > 0 || this.checkedFinish.length > 0 || this.checkedEdge.length > 0 ||
        this.checkedShadeVariationsTile.length > 0 || this.checkedCountry.length > 0 || this.checkedInteriorDesign.length > 0 || this.isMicroban !== null || this.isMadeInUSA !== null)
    },
    filteredSearchTiles() {
      if (this.searchColors && this.searchColors.edges.length > 0) {
        let newResults = []
        let results = _.filter(this.searchColors.edges, (o) => { return o.node.sku })
        /*results = _.filter(results, (o) => { return [(this.residentialSwitch) ? 'Residential' : 'Commercial', 'Residential/Commercial'].includes(o.node.users) })*/
        results = _.filter(results, (o) => { return !o.node.shape.code.startsWith('CUT-SAMPLE') })
        if (this.checkedSeries.length > 0) {
          results = _.filter(results, (o) => { return this.checkedSeries.includes(o.node.seriesName) })
        }
        if (this.checkedColors.length > 0) {
          results = _.filter(results, (o) => { return this.checkedColors.includes(o.node.family) })
        }
        if (this.checkedLooks.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedLooks, o.node.looks.split(',')).length > 0 })
        }
        if (this.checkedSizes.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedSizes, o.node.sizes.split(',')).length > 0 })
        }
        if (this.checkedShapes.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedShapes, o.node.shapes.split(',')).length > 0 })
        }
        if (this.checkedTrims.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedTrims, o.node.trims.split(',')).length > 0 })
        }
        /*else {
          results = _.filter(results, (o) => { return !o.node.onlyTrims })
        }*/
        if (this.checkedApplications.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedApplications, o.node.applications.split(',')).length > 0 })
        }
        if (this.checkedThickness.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedThickness, o.node.thicknesses.split(',')).length > 0 })
        }
        if (this.checkedFinish.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedFinish, o.node.finishes.split(',')).length > 0 })
        }
        if (this.checkedEdge.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedEdge, o.node.edges.split(',')).length > 0 })
        }
        if (this.checkedShadeVariationsTile.length > 0) {
          results = _.filter(results, (o) => { return this.checkedShadeVariationsTile.includes(o.node.shadeVariation) })
        }
        if (this.checkedCountry.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedCountry, o.node.countriesOfOrigin.split(',')).length > 0 })
        }
        if (this.checkedInteriorDesign.length > 0) {
          results = _.filter(results, (o) => { return this.checkedInteriorDesign.includes(o.node.interiorDesignStyle) })
        }
        if (this.checkedTypes.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedTypes, o.node.types.split(',')).length > 0 })
        }
        // if (this.isMadeInUSA) {
        //   filters['madeInUsa'] = { 'value': true }
        // }
        if (this.isMicroban !== null) {
          results = _.filter(results, (o) => { return o.node.hasMicroban === this.isMicroban })
        }
        if (this.checkedDecoratives.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedDecoratives, o.node.decoratives.split(',')).length > 0 })
        }
        /*else {
          results = _.filter(results, (o) => { return !o.node.onlyDecoratives })
        }*/
        if (this.checkedMosaics.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedMosaics, o.node.mosaics.split(',')).length > 0 })
        }
        /*else {
          results = _.filter(results, (o) => { return !o.node.onlyMosaics })
        }*/
        for (const object of results) {
          // if (_.find(newResults, (o) => { return o.seriesName === object.node.seriesName && o.name === object.node.name }) === undefined) {
          newResults.push(object.node)
          // }
        }
        newResults = _.sortBy(newResults, ['onlyDecoratives','onlyMosaics','seriesName', 'name'])
        return newResults
      }
      else {
        return []
      }
    },
    filteredSearchSeries() {
      if (this.searchSeries && this.searchSeries.edges.length > 0) {
        let newResults = []
        let results = this.searchSeries.edges
        if (this.checkedLooks.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedLooks, o.node.looks.split(',')).length > 0 })
        }
        if (this.checkedTypes.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedTypes, o.node.types.split(',')).length > 0 })
        }
        if (this.checkedMosaics.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedMosaics, o.node.mosaics.split(',')).length > 0 })
        }
        if (this.checkedTrims.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedTrims, o.node.trims.split(',')).length > 0 })
        }
        if (this.checkedFinish.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedFinish, o.node.finishes.split(',')).length > 0 })
        }
        if (this.checkedEdge.length > 0) {
          results = _.filter(results, (o) => { return _.intersection(this.checkedEdge, o.node.edges.split(',')).length > 0 })
        }
        if (this.isMicroban !== null) {
          results = _.filter(results, (o) => { return o.node.microban === this.isMicroban })
        }
        if (this.checkedShadeVariationsSeries.length > 0) {
          results = _.filter(results, (o) => { return this.checkedShadeVariationsSeries.includes(o.node.shadeVariation) })
        }
        if (this.isMadeInUSA !== null) {
          results = _.filter(results, (o) => { return o.node.madeInUsa === this.isMadeInUSA })
        }
        for (const object of results) {
          newResults.push(object.node)
        }
        return newResults
      }
      else {
        return []
      }
    },
    currentTileCountOffset() {
      if (this.resultsPage > 1) {
        return this.tileResults.length + ((this.lastLimit - this.firstLimit) * this.resultsPage) - (this.lastLimit - this.firstLimit)
      }
      else {
        return this.tileResults.length
      }
    }
  },
  watch: {
    checkedAlls: function(newValue, oldValue) {
      if (newValue.includes('series')) {
        this.checkedSeries = this.filters.series.map((item) => {
          return item.name
        })
      }
      else if (oldValue.includes('series')) {
        this.checkedSeries = []
      }
      if (newValue.includes('colors')) {
        this.checkedColors = this.filters.color.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('colors')) {
        this.checkedColors = []
      }
      if (newValue.includes('looks')) {
        this.checkedLooks = this.filters.look.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('looks')) {
        this.checkedLooks = []
      }
      if (newValue.includes('sizes')) {
        this.checkedSizes = this.filters.size.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('sizes')) {
        this.checkedSizes = []
      }

      if (newValue.includes('types')) {
        this.checkedTypes = this.filters.type.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('types')) {
        this.checkedTypes = []
      }

      if (newValue.includes('shapes')) {
        this.checkedShapes = this.filters.shape.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('shapes')) {
        this.checkedShapes = []
      }

      if (newValue.includes('decoratives')) {
        this.checkedDecoratives = this.filters.decoratives.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('decoratives')) {
        this.checkedDecoratives = []
      }

      if (newValue.includes('mosaics')) {
        this.checkedMosaics = this.filters.mosaics.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('mosaics')) {
        this.checkedMosaics = []
      }

      if (newValue.includes('trims')) {
        this.checkedTrims = this.filters.trim.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('trims')) {
        this.checkedTrims = []
      }

      if (newValue.includes('applications')) {
        this.checkedApplications = this.filters.application.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('applications')) {
        this.checkedApplications = []
      }

      if (newValue.includes('finishes')) {
        this.checkedFinish = this.filters.finish.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('finishes')) {
        this.checkedFinish = []
      }

      if (newValue.includes('edges')) {
        this.checkedEdge = this.filters.edge.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('edges')) {
        this.checkedEdge = []
      }

      if (newValue.includes('shades')) {
        this.checkedShadeVariationsTile = this.filters.shade.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('shades')) {
        this.checkedShadeVariationsTile = []
      }

      if (newValue.includes('countries')) {
        this.checkedCountry = this.filters.country.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('countries')) {
        this.checkedCountry = []
      }

      if (newValue.includes('shadeSeries')) {
        this.checkedShadeVariationsSeries = this.filters.shadeSeries.map((item) => {
          return item
        })
      }
      else if (oldValue.includes('shadeSeries')) {
        this.checkedShadeVariationsSeries = []
      }

      this.resultsPage = 1
      this.paginationDirection = 'forward'
      this.searchTileAfter = undefined
      this.searchTileBefore = undefined
    },
    checkedSeries: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedColors: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedLooks: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedSizes: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedShapes: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedMosaics: function(newValue, oldValue) {
      this.allMosaics = false
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedTrims: function(newValue, oldValue) {
      this.allTrims = false
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedApplications: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedFinish: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedDecoratives: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedEdge: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedShadeVariationsTile: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedCountry: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedInteriorDesign: function(newValue, oldValue) {
      if (!this.searchingCollections) {
        if (!this.isLoading) {
          this.resultsPage = 1
          this.paginationDirection = 'forward'
          this.searchTileAfter = undefined
          this.searchTileBefore = undefined
        }
      }
    },
    checkedTypes: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    checkedThickness: function(newValue, oldValue) {
      if (!this.isLoading) {
        this.resultsPage = 1
        this.paginationDirection = 'forward'
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
      }
    },
    isMicroban: function(newValue, oldValue) {
      if (!this.searchingCollections) {
        if (!this.isLoading) {
          this.resultsPage = 1
          this.paginationDirection = 'forward'
          this.searchTileAfter = undefined
          this.searchTileBefore = undefined
        }
      }
    },
    residentialSwitch: function() {
      if (!this.searchingCollections) {
        if (!this.isLoading) {
          this.resultsPage = 1
          this.paginationDirection = 'forward'
          this.searchTileAfter = undefined
          this.searchTileBefore = undefined
        }
      }
    }
    // resultsPageSelect: function(newValue, oldValue) {
    //   if (newValue != oldValue && oldValue != null) {
    //     this.resultsPage = parseInt(newValue)
    //     this.$apollo.queries.searchColors.refetch()
    //     this.searchTileAfter = undefined
    //     this.searchTileBefore = undefined
    //     this.$scrollTo('#search-page-container')
    //   }
    // },
    // allTrims (newValue, oldValue) {
    //   if (newValue) {
    //     this.checkedTrims = ['all']
    //   }
    // }
  },
  mixins: [global_mixin]
})



// WEBPACK FOOTER //
// ./core/vue/js/product_search.js